import { render } from "./customerQualityControl.vue?vue&type=template&id=e5f77a40&scoped=true"
import script from "./customerQualityControl.vue?vue&type=script&lang=js"
export * from "./customerQualityControl.vue?vue&type=script&lang=js"

import "./customerQualityControl.vue?vue&type=style&index=0&id=e5f77a40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5f77a40"

export default script